import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { blogsSection } from "../../portfolio.js";
import "./Blogs.css";

class Blogs extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="blogs-main">
        <Header theme={theme} />
        <div className="basic-blogs">
          <div className="blogs-heading-div">
            <div className="blogs-heading-text-div">
              <h1 className="blogs-heading-text" style={{ color: theme.text }}>
                {blogsSection.title}
              </h1>
              <p
                className="blogs-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {blogsSection.subtitle}
              </p>
            </div>
          </div>
          <div className="blogs-cards-div">
            {blogsSection.blogs.map((blog, index) => (
              <Link
                to={`/blogs/${blog.slug}`}
                className="blog-card-link"
                key={index}
              >
                <div
                  className="blog-card"
                  style={{
                    backgroundColor: theme.highlight,
                    boxShadow: `0 4px 15px rgba(0,0,0,0.1)`,
                  }}
                >
                  {blog.coverImage && (
                    <div className="blog-card-image-container">
                      <img
                        src={blog.coverImage}
                        alt={blog.title}
                        className="blog-card-img"
                      />
                    </div>
                  )}
                  <div className="blog-card-content">
                    <h2
                      className="blog-card-title"
                      style={{ color: theme.text }}
                    >
                      {blog.title}
                    </h2>
                    <p
                      className="blog-card-description"
                      style={{ color: theme.secondaryText }}
                    >
                      {blog.description}
                    </p>
                    <div className="blog-card-footer">
                      {blog.date && (
                        <span
                          className="blog-card-date"
                          style={{ color: theme.secondaryText }}
                        >
                          {blog.date}
                        </span>
                      )}
                      {blog.readTime && (
                        <span
                          className="blog-card-read-time"
                          style={{ color: theme.secondaryText }}
                        >
                          {blog.readTime}
                        </span>
                      )}
                    </div>
                    {blog.tags && (
                      <div className="blog-card-tags">
                        {blog.tags.slice(0, 3).map((tag, i) => (
                          <span
                            key={i}
                            className="blog-card-tag"
                            style={{ color: theme.text }}
                          >
                            #{tag}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Blogs;
